<template>
  <div>
    <label>{{ $t("table.columnsToSearch") }}</label>
    <v-autocomplete
      v-model="selected"
      :items="items"
      multiple
      clearable
      chips
      deletable-chips
      hide-details
      small-chips
      dense
    >
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped></style>
